import React, { memo, useEffect, useRef } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import s from './SlRichText.scss';

export interface ISlRichTextProps {
	content: string;
}

const specialChars = {
	'&': '&amp;',
	'<': '&lt;',
	'>': '&gt;',
};

export const SlRichText = memo(({ content }: ISlRichTextProps): JSX.Element => {
	useStyles(s);
	const contentDiv = useRef(null);

	useEffect(() => {
		// Todo: to be discussed about predefined colors, to be removed this part
		if (content) {
			contentDiv.current.style.display = 'none';
			const nodes = contentDiv.current.getElementsByTagName('*');
			for (const node of nodes) {
				const color = node.dataset.color;
				const backgroundColor = node.dataset.backgroundColor;

				if (color) {
					node.style.color = color;
				}
				if (backgroundColor) {
					node.style.backgroundColor = backgroundColor;
				}
			}
			contentDiv.current.style.display = 'block';
		}
	}, []);

	// Avoid parse tags inside <code> tag
	const replacedHtml = content.replace(/<code>(.*?)<\/code>/g, (match, code) => {
		return `<code>${code.replace(/&(?!amp;)|[<>]/g, (char) => {
			return specialChars[char];
		})}</code>`;
	});


	return (
		<div
			className="sl-rich-text"
			sl-test-data="cmpSlRichText"
			ref={contentDiv}
			dangerouslySetInnerHTML={{ __html: replacedHtml }}
		/>
	);
});
